<template>
  <ed-dialog ref="BasicDialog" :fullscreen="true" :showOkBtn="false" :visible="visible"
             title="接口变量管理"
             @close="closeDialog">
    <easy-data-list ref="EasyDataList" :data-source-name="dataSourceName"></easy-data-list>
  </ed-dialog>
</template>

<script>

export default {
  name: "InterfaceVariable",
  data() {
    return {
      visible: false,
      dataSourceName: 'interface_variable'
    }
  },
  methods: {
    show() {
      this.visible = true;
    },
    closeDialog() {
      this.visible = false;
    }
  }
}
</script>

<style scoped>
</style>
